import React from "react";
import DataProvider from "./contexts/data-context";
import ArticlesProvider from "./contexts/articles-context";
import { withRouter } from "react-router-dom";

const DataLayer = ({ children, location: { pathname, search } }) => {
  const isRestricted = () => {
    return !/^\/(auth|public)(?=\/|$)/i.test(pathname);
  }

  const CustomLayer = () => {
    if (!isRestricted()) {
      return children
    }
    const queryParameters = new URLSearchParams(search)
    return <DataProvider product={queryParameters.get('product')}><ArticlesProvider>{children}</ArticlesProvider></DataProvider>
  }

  return CustomLayer();
}

export default withRouter(DataLayer)
